"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rox = exports._RoxClient = exports.RoxOverridesPosition = exports.RoxFetcherStatus = exports.RoxNumber = exports.RoxString = exports.Flag = void 0;
var utils_1 = require("./utils");
var flag_1 = require("./flag");
Object.defineProperty(exports, "Flag", { enumerable: true, get: function () { return flag_1.Flag; } });
var string_1 = require("./string");
Object.defineProperty(exports, "RoxString", { enumerable: true, get: function () { return string_1.RoxString; } });
var number_1 = require("./number");
Object.defineProperty(exports, "RoxNumber", { enumerable: true, get: function () { return number_1.RoxNumber; } });
var RoxFetcherStatus;
(function (RoxFetcherStatus) {
    RoxFetcherStatus["AppliedFromEmbedded"] = "APPLIED_FROM_EMBEDDED";
    RoxFetcherStatus["AppliedFromCache"] = "APPLIED_FROM_CACHE";
    RoxFetcherStatus["AppliedFromNetwork"] = "APPLIED_FROM_NETWORK";
    RoxFetcherStatus["ErrorFetchFailed"] = "ERROR_FETCH_FAILED";
})(RoxFetcherStatus = exports.RoxFetcherStatus || (exports.RoxFetcherStatus = {}));
var RoxOverridesPosition;
(function (RoxOverridesPosition) {
    RoxOverridesPosition["TopLeft"] = "top left";
    RoxOverridesPosition["TopRight"] = "top right";
    RoxOverridesPosition["BottomLeft"] = "bottom left";
    RoxOverridesPosition["BottomRight"] = "bottom right";
})(RoxOverridesPosition = exports.RoxOverridesPosition || (exports.RoxOverridesPosition = {}));
var _RoxClient = (function () {
    function _RoxClient() {
        this.dynamicApi = utils_1.internalRox.dynamicApi;
        this.overrides = utils_1.internalRox.overrides;
        this.alreadyInitialized = false;
        this._configurationFetchedHandlers = [];
        this._rolloutData = {};
    }
    _RoxClient.prototype.register = function (namespace, roxContainer) {
        utils_1.internalRox.register(namespace, roxContainer);
    };
    _RoxClient.prototype.setup = function (apiKey, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _options;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.alreadyInitialized) {
                            throw new Error('Rox cannot be initialized more than once');
                        }
                        _options = __assign({}, options);
                        if ((0, utils_1.isBrowser)() && window && window.rolloutData) {
                            Object.assign(_options, options, {
                                embedded: window.rolloutData,
                                disableNetworkFetch: true,
                            });
                            if (_options.disablePushUpdateListener !== false) {
                                _options.disablePushUpdateListener = true;
                            }
                        }
                        if (!_options.platform) {
                            _options.platform = 'SSR';
                        }
                        if (options === null || options === void 0 ? void 0 : options.configurationFetchedHandler) {
                            this._configurationFetchedHandlers.push(options.configurationFetchedHandler);
                        }
                        _options.configurationFetchedHandler = this._configurationFetchedHandler();
                        return [4, utils_1.internalRox.setup(apiKey, _options)];
                    case 1:
                        _a.sent();
                        this.alreadyInitialized = true;
                        return [2];
                }
            });
        });
    };
    _RoxClient.prototype.setContext = function (globalContext) {
        utils_1.internalRox.setContext(globalContext);
    };
    _RoxClient.prototype.setCustomNumberProperty = function (name, value) {
        utils_1.internalRox.setCustomNumberProperty(name, value);
    };
    _RoxClient.prototype.setCustomStringProperty = function (name, value) {
        utils_1.internalRox.setCustomStringProperty(name, value);
    };
    _RoxClient.prototype.setCustomBooleanProperty = function (name, value) {
        utils_1.internalRox.setCustomBooleanProperty(name, value);
    };
    _RoxClient.prototype.fetch = function () {
        utils_1.internalRox.fetch();
    };
    _RoxClient.prototype.showOverrides = function (position) {
        if ((0, utils_1.isBrowser)()) {
            utils_1.internalRox.showOverrides(position);
            return;
        }
        throw new Error('showOverrides is only available in a browser context');
    };
    _RoxClient.prototype._configurationFetchedHandler = function () {
        var roxClient = this;
        return function (fetcherResults) {
            if (fetcherResults.hasChanges) {
                roxClient._rolloutData = fetcherResults.clientData;
            }
            roxClient._configurationFetchedHandlers.forEach(function (cfh) { return cfh(fetcherResults); });
        };
    };
    Object.defineProperty(_RoxClient.prototype, "rolloutData", {
        get: function () {
            return JSON.stringify(this._rolloutData);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(_RoxClient.prototype, "flags", {
        get: function () {
            return utils_1.internalRox.flags;
        },
        enumerable: false,
        configurable: true
    });
    return _RoxClient;
}());
exports._RoxClient = _RoxClient;
exports.Rox = new _RoxClient();
//# sourceMappingURL=index.js.map